import { Injectable } from '@angular/core';
import { LoadingController, ModalController, ModalOptions } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmModalComponent } from '../../components/confirm-modal/confirm-modal.component';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private currentLoading: Promise<HTMLIonLoadingElement> | null = null;

  constructor(
    private loadingController: LoadingController,
    private translate: TranslateService,
    private modalController: ModalController
  ) { }

  async show(messageKey: string = 'common.please_wait', backdropDismiss: boolean = false, messageParams: any = {} ) {
    await this.dismiss();
    const message = this.translate.instant(messageKey, messageParams);
    const loadingPromise = this.loadingController.create({
      message,
      backdropDismiss
    });
    this.currentLoading = loadingPromise;
    const loading = await loadingPromise;
    if (this.currentLoading === loadingPromise) {
      await loading.present();
    } else {
      await loading.dismiss().catch(() => null);
    }
  }

  async dismiss() {
    const pending = this.currentLoading;
    this.currentLoading = null;
    if (pending) {
      const loading = await pending;
      await loading.dismiss().catch(() => null);
      return;
    }
    const loading = await this.loadingController.getTop();
    if (loading) {
      await loading.dismiss();
    }
  }

  async showConfirmModal(
    message: string, title: string = '',
    options?: {
      centerText?: boolean,
      cancelRole?: string,
      cancelText?: string,
      cancelButtonColor?: string,
      confirmRole?: string,
      confirmText?: string,
      confirmButtonColor?: string,
    },
    backdropDismiss: boolean = false
  ) {
    let confirmText = options?.confirmText || this.translate.instant('common.confirm');
    let cancelText = options?.confirmText || this.translate.instant('common.cancel');

    const confirmModal = await this.modalController.create({
      component: ConfirmModalComponent,
      componentProps: {
        title,
        message,
        centerText: options?.centerText || true,
        cancelRole: options?.cancelRole || 'cancel',
        cancelText: cancelText,
        cancelButtonColor: options?.cancelButtonColor || 'light',
        confirmRole: options?.confirmRole || 'confirm',
        confirmText: confirmText,
        confirmButtonColor: options?.confirmButtonColor || 'primary',
      },
      cssClass: 'confirm-modal',
      backdropDismiss
    });
    return confirmModal;
  }
}